/** @format */
import { api } from 'utility';
import { fileDownloader } from 'utility/util';
import jMoment from 'moment-jalaali';
import { enifyDateTime } from 'utility';
import {
  getGuildServiceUrl,
  getDeleteOrEditGuildUrl,
  getCreditUrl,
  getPaymentServiceUrl,
  getShebaGuildUrl,
  getFinancialTransferUrl,
  getShebaServiceUrl,
  getCardServiceUrl,
  getToggleAutoSettelmentUrl,
  getPaginateReportSaleInvoiceUrl,
  getReportSaleInvoiceUrl,
  getExportReportSaleInvoiceUrl,
  getInvoiceSaleListIdUrl,
  getReportPurchaseInvoiceUrl,
  getExportReportPurchaseInvoiceUrl,
  getDetaileSettelmentUrl,
  getRequestSettelmentFromGuildUrl,
  getFinancialSettelmentWallet,
  getBusinessUrl,
  getReportBillsUrl,
  getExportBillReportUrl,
  getReportAccountNumberUrl,
  getReportSettelmentRequestUrl,
  getExportRequestSettelmentUrl,
  getPayInvoiceByCreditUrl,
  getCallbackuriListUrl,
  getAddressExportFileUrl,
  getRequestOtpCodeUrl,
  getExportCompositeBillsInvoicesUrl,
  getExportBillBankFormatReportUrl,
  getlastTransactionUrl,
  getReportBillsExportPdfUrl,
  cartablePayInvoiceUrl,
  getInvoiceSaleList,
  getCarTableListUrl,
  getInvoicePurchesList,
  getCategoryInvociePayment
} from 'URLs';

const source = api.cancelToken;
let cancelToken;

export function createAccount(params) {
  return api.post(getGuildServiceUrl(), {
    ...params,
  });
}

export function aliasNameAccount(params, guild) {
  return api.put(getDeleteOrEditGuildUrl(guild), params);
}

export function getCategoryListInvoice(params) {
  return api.get(getCategoryInvociePayment(), { params }).then((res) => res.data);
}
export function credit() {
  return api.get(getCreditUrl()).then((res) => res.data);
}
export function creditHasTotalInfo() {
  return api.get(getCreditUrl(), {}).then((res) => res.data);
}
export function charge(params) {
  return api.get(getPaymentServiceUrl(), { params }).then((res) => res.data);
}

export function getShebaAccount(params) {
  return api.get(getShebaGuildUrl(), { params }).then((res) => res.data);
}

export function moneyTransfer(param) {
  return api.post(getFinancialTransferUrl(), {
    ...param,
  });
}

export function reportFactorsDebtor(param, dataParams) {
  return api.post(getPaginateReportSaleInvoiceUrl(param.size, param.page), {
    ...dataParams,
  });
}
export function reportInvoiceDebtor(data, params) {
  return api.post(getReportSaleInvoiceUrl(), data, { params }).then((res) => res.data);
}

export function getListInvoiceReport(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .get(getInvoicePurchesList(), { params, cancelToken: cancelToken.token })
    .then((res) => res.data);
}

export function getListInvoice(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .get(getInvoiceSaleList(), { params, cancelToken: cancelToken.token })
    .then((res) => res.data);
}
export function reportInvoiceDebtorExport(data, params, exportType, onError) {
  return fileDownloader(
    'POST',
    getExportReportSaleInvoiceUrl(exportType),
    params,
    data,
    null,
    exportType,
    null,
    onError,
  );
}

export function reportFactorsDetailsDebtor(id) {
  return api.get(getInvoiceSaleListIdUrl(id)).then((res) => res.data);
}

export function reportFactorsDetailsDebtorSecondary(invoiceId) {
  const params = {
    page: 0,
    size: 10,
  };
  const data = {
    filterVOS: [
      {
        id: '1349',
        key: 'invoiceId',
        value: invoiceId,
      },
    ],
    orderByElementVOS: [],
    parentParams: [
      {
        key: 'START_DATE',
        value: enifyDateTime(
          jMoment(new Date().setHours(0, 0, 0, 0))
            .subtract(365, 'days')
            ?.format('jYYYY/jMM/jDD HH:mm:ss'),
        ),
      },
      {
        key: 'END_DATE',
        value: enifyDateTime(jMoment(new Date())?.format('jYYYY/jMM/jDD HH:mm:ss')),
      },
    ],
  };
  return api.post(getReportSaleInvoiceUrl(), data, { params }).then((res) => res.data);
}

export function reportFactorsDetails(param, dataParams) {
  return api.post(getPaginateReportSaleInvoiceUrl(param.size, param.page), {
    ...dataParams,
  });
}

export function reportFactorsCreditor(data, params) {
  return api.post(getReportPurchaseInvoiceUrl(), data, { params }).then((res) => res.data);
}

export function reportFactorsCreditorExport(dataParams, params, type, onError) {
  return fileDownloader(
    'POST',
    getExportReportPurchaseInvoiceUrl(type),
    params,
    dataParams,
    null,
    type,
    null,
    onError,
  );
}

export function getSheba(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }
  cancelToken = source.source();
  return api
    .get(getShebaServiceUrl(), { params, cancelToken: cancelToken.token })
    .then((res) => res.data);
}

export function deleteGuild(code) {
  return api.delete(getDeleteOrEditGuildUrl(code), {}).then((res) => res.data);
}

export function getCard(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();

  return api.get(getCardServiceUrl(), { params, cancelToken: cancelToken.token }).then((res) => {
    return res.data.result.filter((item) => {
      return item?.number;
    });
  });
}

export function autoSettlement(param) {
  return api.post(getToggleAutoSettelmentUrl(), {
    ...param,
  });
}

export function deleteSettlement(param) {
  return api.delete(getToggleAutoSettelmentUrl(), { params: { ...param } });
}

export function deleteSettlementById(id) {
  return api.delete(getDetaileSettelmentUrl(id), {});
}

export function withdrawal(param) {
  return api.post(getRequestSettelmentFromGuildUrl(), {
    ...param,
  });
}

export function withdrawalWallet(param) {
  return api.post(getFinancialSettelmentWallet(), {
    ...param,
  });
}

export function getBusiness() {
  return api.get(getBusinessUrl());
}

export function reportTransaction(data, params) {
  return api.post(getReportBillsUrl(), data, { params }).then((res) => res.data);
}

export function reportTransactionExport(data, params, exportType, onError) {
  return fileDownloader(
    'POST',
    getExportBillReportUrl(exportType),
    params,
    data,
    null,
    exportType,
    null,
    onError,
  );
}

export function reportAccountNumber() {
  return api.get(getReportAccountNumberUrl()).then((res) => res.data);
}

export function reportSettlementApi(data, params) {
  return api.post(getReportSettelmentRequestUrl(), data, { params }).then((res) => res.data);
}

export function reportSettlementApiExport(data, params, exportType, onError) {
  return fileDownloader(
    'POST',
    getExportRequestSettelmentUrl(exportType),
    params,
    data,
    null,
    exportType,
    null,
    onError,
  );
}

export function reportSettlementStatusApi(id) {
  const headers = {
    idToken: 'true',
  };
  return api.get(getDetaileSettelmentUrl(id), { headers: { ...headers } }).then((res) => res.data);
}

export function reportSettlementListApi(params) {
  return api.get(getRequestSettelmentFromGuildUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export function payInvoiceWithCredit(invoiceId) {
  return api.post(getPayInvoiceByCreditUrl(invoiceId));
}

export function getBusinessCallbackUri(params) {
  return api.get(getCallbackuriListUrl(), { params }).then((res) => res.data);
}

export function getSettlementList(params, url) {
  return api.get(url, { params }).then((res) => res.data);
}

/**
 * پیامک - کد دو عاملی
 */
export function requestMessage() {
  return api.post(getRequestOtpCodeUrl()).then((res) => res.data);
}

export function requestGetExportFile(type, data, params) {
  return api
    .post(getExportCompositeBillsInvoicesUrl(type), data, { params })
    .then((res) => res.data);
}
export function getAddressExportFile() {
  return api.get(getAddressExportFileUrl()).then((res) => res.data);
}
/**
 * خروجی با فرمت بانکی
 */
export function reportFormatBank(type, params, data) {
  return api.post(getExportBillBankFormatReportUrl(type), data, { params }).then((res) => res.data);
}
export function reportGetDateFromServer(params) {
  return api.get(getlastTransactionUrl(), { params }).then((res) => res.data);
}

/**
 * خروجی فایل با فرمت pdf - در صورت حساب دیجیتال و تفصیلی - در کبوباکس خروجی فایل با عنوان درخواست فایل خروجی با فرمت pdf -
 */
export function reportBillsExportPdf(data) {
  return api.post(getReportBillsExportPdfUrl(), data, {}).then((res) => res.data);
}
/**
 * بررسی اینکه این حساب کارتابل هست یا خیر؟
 */
export function getCarTableList(data) {
  return api.post(getCarTableListUrl(), data).then((res) => res.data);
}

/**
 *
 * پرداخت فاکتور کارتابلی
 */
export function postCartableFactor(params) {
  return api.post(cartablePayInvoiceUrl(), {}, { params }).then((res) => res.data);
}